import React, { useState } from "react";
import { InputField } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

// Fungsi untuk memformat tanggal ke format Indonesia
const formatDate = (dateString) => {
  if (!dateString) return "Tanggal belum ditentukan";
  try {
    // Menangani format tanggal seperti "26/09/2025"
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Tanggal belum ditentukan";
  } catch {
    return "Tanggal belum ditentukan";
  }
};

// Fungsi untuk memparse waktu untuk pengurutan
const parseTime = (time) => {
  const startTime = time ? time.split(" - ")[0] : "00:00";
  const [hours, minutes] = startTime.split(":").map(Number);
  return hours * 60 + minutes;
};

export const Rundown = ({ categoryName }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  // Data rundown statis berdasarkan kategori
  const rundowns = {
    "Vertical (7K)": [
      {
        date: "28/09/2025",
        time: "05:30",
        activity: "Open Gate Vertical / Fun Trail (7KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "06:30",
        activity: "Flag Off - Vertical (7KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:00 - 14:30",
        activity: "Penyerahan Podium Vertical & Classic / Fun Trail",
        location: "Venue Balai Besar TNGGP",
      },
    ],
    "Fun Trail (7K)": [
      {
        date: "28/09/2025",
        time: "05:30",
        activity: "Open Gate Vertical / Fun Trail (7KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "07:00",
        activity: "Flag Off - Fun Trail (7KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "11:00",
        activity: "Cut Off Time Fun Trail (7KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:00 - 14:30",
        activity: "Penyerahan Podium Vertical & Classic / Fun Trail",
        location: "Venue Balai Besar TNGGP",
      },
    ],
    "Classic Distance (20K)": [
      {
        date: "28/09/2025",
        time: "02:00",
        activity: "Open Gate Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "03:00",
        activity: "Flag Off - Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "10:30",
        activity: "COP 1 (Classic / Group Mix 20KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "15:00",
        activity: "Cut Off Time Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:00 - 14:30",
        activity: "Penyerahan Podium Vertical & Classic / Fun Trail",
        location: "Venue Balai Besar TNGGP",
      },
    ],
    "Short Distance (40K)": [
      {
        date: "27/09/2025",
        time: "04:30",
        activity: "Open Gate Short Distance (40KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "27/09/2025",
        time: "05:30",
        activity: "Flag Off - Short Distance (40KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "27/09/2025",
        time: "13:00",
        activity: "COP 1 Short Distance (40KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "27/09/2025",
        time: "20:30",
        activity: "COP 2 Short Distance (40KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "01:30",
        activity: "Cut Off Time Short Distance (40KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:30 - 14:45",
        activity: "Penyerahan Podium Short Distance",
        location: "Venue Balai Besar TNGGP",
      },
    ],
    "Long Distance (80 K)": [
      {
        date: "27/09/2025",
        time: "00:00",
        activity: "Open Gate Long Distance (80KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "27/09/2025",
        time: "01:00",
        activity: "Flag Off - Long Distance (80KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "27/09/2025",
        time: "08:30",
        activity: "COP 1 Long Distance (80KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "27/09/2025",
        time: "16:00",
        activity: "COP 2 Long Distance (80KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "02:00",
        activity: "COP 3 Long Distance (80KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "08:00",
        activity: "COP 4 Long Distance (80KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "12:00",
        activity: "Cut Off Time Long Distance (80KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:45 - 15:00",
        activity: "Penyerahan Podium Long Distance",
        location: "Venue Balai Besar TNGGP",
      },
    ],
    "Mix Group (20K)": [
      {
        date: "28/09/2025",
        time: "02:00",
        activity: "Open Gate Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "03:00",
        activity: "Flag Off - Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "10:30",
        activity: "COP 1 (Classic / Group Mix 20KM)",
        location: "Alun-Alun Tengah Surya Kencana",
      },
      {
        date: "28/09/2025",
        time: "15:00",
        activity: "Cut Off Time Classic / Group Mix (20KM)",
        location: "Venue Balai Besar TNGGP",
      },
      {
        date: "28/09/2025",
        time: "14:00 - 14:30",
        activity: "Penyerahan Podium Vertical & Classic / Fun Trail",
        location: "Venue Balai Besar TNGGP",
      },
    ],
  };

  const rundownList = rundowns[trimmedCategoryName];

  // Jika categoryName tidak valid atau tidak ada rundown, tampilkan pesan
  if (!trimmedCategoryName || !rundownList || rundownList.length === 0) {
    return (
      <div className="px-4 py-4 text-sm text-gray-600 text-center">
        Tidak ada data rundown tersedia untuk kategori{" "}
        {trimmedCategoryName || "tidak diketahui"}.
      </div>
    );
  }

  // Filter berdasarkan searchQuery
  const filteredRundown = rundownList.filter((entry) =>
    Object.values(entry).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Kelompokkan rundown berdasarkan tanggal
  const groupedRundown = filteredRundown.reduce((acc, entry) => {
    const formattedDate = formatDate(entry.date);
    acc[formattedDate] = acc[formattedDate] || [];
    acc[formattedDate].push(entry);
    return acc;
  }, {});

  // Urutkan entri berdasarkan waktu
  Object.keys(groupedRundown).forEach((date) => {
    groupedRundown[date].sort((a, b) => parseTime(a.time) - parseTime(b.time));
  });

  return (
    <div>
      <div className="flex justify-end mb-4 px-4 pt-4">
        <div className="w-full max-w-xs">
          <InputField
            name="search"
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Cari rundown..."
            labelColor="text-lime-800"
            startIcon={
              <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
            }
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto divide-y divide-slate-200">
          <thead>
            <tr className="bg-gray-100 divide-x divide-slate-200">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Tanggal
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Waktu
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Aktivitas
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Lokasi
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {Object.keys(groupedRundown).length > 0 ? (
              Object.entries(groupedRundown).map(([date, entries], groupIdx) =>
                entries.map((entry, idx) => {
                  const isCutOff = entry.activity.includes("Cut Off Time");
                  const isFlagOff = entry.activity.includes("Flag Off");
                  const isDate28 = entry.date === "28/09/2025";
                  const rowColor = isFlagOff
                    ? "text-lime-600"
                    : isCutOff
                    ? "text-red-600"
                    : "text-gray-600";
                  return (
                    <tr
                      key={`${groupIdx}-${idx}`}
                      className={`border-b border-slate-200 last:border-b-0 transition-colors duration-200 hover:bg-gray-50 ${rowColor} divide-x divide-slate-200`}
                    >
                      <td
                        className={`px-4 py-4 text-sm text-left ${
                          isCutOff && isDate28 ? "text-gray-600" : rowColor
                        }`}
                      >
                        {idx === 0 ? date : ""}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.time || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.activity || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-left">
                        {entry.location || "-"}
                      </td>
                    </tr>
                  );
                })
              )
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-4 text-sm text-gray-600 text-center"
                >
                  Tidak ada data rundown tersedia untuk kategori{" "}
                  {trimmedCategoryName}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
